import React from 'react';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export default function ConfirmDialog({ open, title, message, onClose, onConfirm, loading = false }) {
  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { backgroundColor: '#161b22', border: '1px solid #30363d' } }}>
      <DialogTitle sx={{ color: '#f0f6fc' }}>{title || ''}</DialogTitle>
      <DialogContent>
        <Typography sx={{ color: '#c9d1d9' }}>{message || ''}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: '#7d8590' }} disabled={!!loading}>Cancel</Button>
        <Button
          onClick={() => { if (typeof onConfirm === 'function') onConfirm(); }}
          variant={loading ? 'contained' : 'outlined'}
          disabled={!!loading}
          sx={{
            color: loading ? '#0d1117' : '#58a6ff',
            backgroundColor: loading ? '#3fb950' : 'transparent',
            borderColor: loading ? '#2ea043' : '#58a6ff',
            '&:hover': { backgroundColor: loading ? '#2ea043' : '#58a6ff20' },
            '&.Mui-disabled': { backgroundColor: '#3fb950', color: '#0d1117', borderColor: '#2ea043', opacity: 1 },
          }}
        >
          {loading ? (
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} sx={{ color: '#0d1117' }} />
              Committing…
            </Box>
          ) : 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}




